export class UpdateCredentialsProfileInputAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateCredentialsProfileInputAws.attributeTypeMap;
    }
    constructor() {
    }
}
